import React from 'react'

function Industries() {
  return (
    <>
    <section className="ttm-row service-section ttm-bgcolor-grey position-relative z-index-2 clearfix">
  <div className="container">
    {/* row */}
    <div className="row">
      <div className="col-lg-12">
        {/* section-title */}
        <div className="section-title title-style-center_text">
          <div className="title-header">
            <h3>INDUSTRIES &amp; PRODUCTION</h3>
            <h2 className="title">Let's Experience <b>Exclusive Quality</b></h2>
          </div>
        </div>{/* section-title end */}
      </div>
    </div>
    {/* row end */}
    <div className="row">
      <div className="col-lg-12">
        <div className="featuredbox-number">
          <div className="row">
            <div className="col-lg-3 col-md-6 col-sm-6">
              {/*featured-icon-box*/}
              <div className="featured-icon-box icon-align-top-content style5">
                <i className="ttm-num ti-info" />
                <div className="featured-icon">
                  <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-skincolor ttm-icon_element-size-md">
                    <i className="flaticon flaticon-textile-1" />
                  </div>
                </div>
                <div className="featured-content">
                  <div className="featured-title">
                    <h3>Fabric Treatment</h3>
                  </div>
                  <div className="featured-desc">
                    <p>We perform fabric stabilization, including reweaving and stitch repairs.</p>
                  </div>
                </div>
              </div>{/* featured-icon-box end*/}
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6">
              {/*featured-icon-box*/}
              <div className="featured-icon-box icon-align-top-content style5">
                <i className="ttm-num ti-info" />
                <div className="featured-icon">
                  <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-skincolor ttm-icon_element-size-md">
                    <i className="flaticon flaticon-silk" />
                  </div>
                </div>
                <div className="featured-content">
                  <div className="featured-title">
                    <h3>Artistic Direction</h3>
                  </div>
                  <div className="featured-desc">
                    <p>We assist with collection strategies, storage solutions, application management, and pest control.</p>
                  </div>
                </div>
              </div>{/* featured-icon-box end*/}
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6">
              {/*featured-icon-box*/}
              <div className="featured-icon-box icon-align-top-content style5">
                <i className="ttm-num ti-info" />
                <div className="featured-icon">
                  <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-skincolor ttm-icon_element-size-md">
                    <i className="flaticon flaticon-moisture-wicking-fabric" />
                  </div>
                </div>
                <div className="featured-content">
                  <div className="featured-title">
                    <h3>Satin weaving</h3>
                  </div>
                  <div className="featured-desc">
                    <p>A weaving technique where the weft yarn runs continuously with minimal interruptions to the warp.</p>
                  </div>
                </div>
              </div>{/* featured-icon-box end*/}
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6">
              {/*featured-icon-box*/}
              <div className="featured-icon-box icon-align-top-content style5">
                <i className="ttm-num ti-info" />
                <div className="featured-icon">
                  <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-skincolor ttm-icon_element-size-md">
                    <i className="flaticon flaticon-sewing-machine" />
                  </div>
                </div>
                <div className="featured-content">
                  <div className="featured-title">
                    <h3>Fabric Dyeing</h3>
                  </div>
                  <div className="featured-desc">
                    <p>We transfer dyes from aqueous solutions onto the fiber surface, allowing for deep diffusion into the fabric.</p>
                  </div>
                </div>
              </div>{/* featured-icon-box end*/}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section className="ttm-row padding_top_zero-section ttm-bgcolor-grey clearfix">
  <div className="container">
    <div className="row">
      <div className="col-lg-4">
        <div className="ttm-bgcolor-white p-30">
          <h3 className="fs-26">Stone Work Embroidery</h3>
          <p>We offer intricate stone work embroidery, adding luxury and detail to textile products.</p>
          {/* <a class="ttm-btn btn-inline ttm-btn-size-md ttm-btn-color-dark margin_top5 margin_bottom5"
                              href="we-design-fabric.html">read more</a> */}
        </div>
      </div>
      <div className="col-lg-8">
        <div className="ttm-bgcolor-skincolor p-30">
          <div className="row ttm-vertical_sep">
            <div className="col-lg-4 col-md-4 col-sm-6">
              {/* ttm-fid */}
              <div className="ttm-fid inside ttm-fid-with-icon ttm-fid-view-lefticon style3">
                <div className="ttm-fid-icon-wrapper">
                  <i className="ti ti-cup" />
                </div>
                <div className="ttm-fid-contents">
                  <h4 className="ttm-fid-inner">
                    <span data-appear-animation="animateDigits" data-from={0} data-to={45} data-interval={5} data-before data-before-style="sup" data-after="+" data-after-style="sub" className="numinate">45
                    </span>
                    <span>+</span>
                  </h4>
                </div>
                <h3 className="ttm-fid-title">Different Types of Textile Products</h3>
              </div>{/* ttm-fid end */}
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6">
              {/* ttm-fid */}
              <div className="ttm-fid inside ttm-fid-with-icon ttm-fid-view-lefticon style3">
                <div className="ttm-fid-icon-wrapper">
                  <i className="ti ti-crown" />
                </div>
                <div className="ttm-fid-contents">
                  <h4 className="ttm-fid-inner">
                    <span data-appear-animation="animateDigits" data-from={0} data-to={25} data-interval={5} data-before data-before-style="sup" data-after="+" data-after-style="sub" className="numinate">25
                    </span>
                    <span>+</span>
                  </h4>
                </div>
                <h3 className="ttm-fid-title">Years of Working Experience</h3>
              </div>{/* ttm-fid end */}
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6">
              {/* ttm-fid */}
              <div className="ttm-fid inside ttm-fid-with-icon ttm-fid-view-lefticon style3">
                <div className="ttm-fid-icon-wrapper">
                  <i className="ti ti-user" />
                </div>
                <div className="ttm-fid-contents">
                  <h4 className="ttm-fid-inner">
                    <span data-appear-animation="animateDigits" data-from={0} data-to={325} data-interval={25} data-before data-before-style="sup" data-after="+" data-after-style="sub" className="numinate">325
                    </span>
                    <span>+</span>
                  </h4>
                </div>
                <h3 className="ttm-fid-title">Satisfied Clients</h3>
              </div>{/* ttm-fid end */}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

    </>

  )
}

export default Industries